<div>
  <p>{{ title }}</p>
  <div class="file">
    <img
      *ngIf="icon?.toLocaleLowerCase().includes('xls')"
      src="assets/img/excel.png"
    />
    <img
      *ngIf="icon?.toLocaleLowerCase().includes('img')"
      width="50"
      height="50"
      src="assets/img/img.svg"
    />
    <i
      *ngIf="icon?.toLocaleLowerCase().includes('pdf')"
      class="bx bxs-file-pdf"
    ></i>
    <i
      *ngIf="icon?.toLocaleLowerCase().includes('doc')"
      class="bx bxs-file"
    ></i>
    <strong
      class="download-link"
      [style.cursor]="uri ? 'pointer' : 'default'"
      (click)="downloadTemplate()"
    >
      {{ text }}
    </strong>
  </div>
</div>
